import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import config from '../../../config';
import { Footer, PageBootstrap } from '../../../components';
import Image from 'react-bootstrap/Image';

import { TopbarContainer } from '../..';
import metaImage from '../img/og/hakuba_ogImage_1200.jpg';

import { propTypes } from '../../../util/types';

import '../AdventurePage.scss';

import aboutImg from '../img/hakuba/about_2040.webp';

import day1 from '../img/akan/itinerary1_800.webp';
import day2 from '../img/akan/itinerary2_800.webp';
import day3 from '../img/akan/itinerary3_800.webp';
import day4 from '../img/akan/itinerary4_800.webp';

import area from '../img/hakuba/area1_2880.webp';
import area2 from '../img/hakuba/area2_960.webp';
import area3 from '../img/hakuba/area3_960.webp';

import highlights from '../img/hakuba/highlights_2880.webp';
import top from '../img/hakuba/top_2880.webp';
import guide from '../img/hakuba/guide_960.webp';

import option1 from '../img/hakuba/options1_2040.webp';
import option2 from '../img/hakuba/options2_2040.webp';

import accommodations1 from '../img/hakuba/accommodations1_668.webp';
import accommodations2 from '../img/hakuba/accommodations2_668.webp';
import accommodations3 from '../img/hakuba/accommodations3_668.webp';
import accommodations4 from '../img/hakuba/accommodations4_668.webp';
import accommodations5 from '../img/hakuba/accommodations5_668.webp';
import accommodations6 from '../img/hakuba/accommodations6_668.webp';
import { ImageGalleryComponent } from '../components/Image';

import HeroContent from '../components/HeroContent';
import TourDetails from '../components/TourDetails';
import SectionComponent from '../components/SectionComponent';
import TwoColumnComponent from '../components/TwoColumnComponent';
import SingleColumnComponent from '../components/SingleColumnComponent';
import Subtitles from '../components/Subtitles';
import Itinerary from '../components/Itinerary';

import { SuggestedAdventures } from '../components/SuggestedAdventures';
import HeroImage from '../components/HeroImage';
import Container from 'react-bootstrap/Container';
import { getTourDetails } from '../utils';
import HighlightSection from '../components/HighlightSection';
import { cardsWinterAndSummer } from '../components/AdventureCard';

export const AdventurePageComponent = props => {
  const { intl } = props;
  const [isTransparent, setIsTransparent] = useState(true);

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format

  const schemaTitle = intl.formatMessage({ id: 'Hakuba.OgTitle' });
  const schemaDescription = intl.formatMessage({ id: 'Hakuba.OgDescription' });
  const schemaImage = `${config.canonicalRootURL}${metaImage}`;

  const inquireLink = config.custom.inquireURL.adventuresWinter('HakubaAdventurePage');

  const imageList = [
    { src: accommodations1, alt: 'Accommodation image' },
    { src: accommodations2, alt: 'Accommodation image' },
    { src: accommodations3, alt: 'Accommodation image' },
    { src: accommodations4, alt: 'Accommodation image' },
    { src: accommodations5, alt: 'Accommodation image' },
    { src: accommodations6, alt: 'Accommodation image' },
  ];

  return (
    <PageBootstrap
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: metaImage }]}
      twitterImages={[{ url: schemaImage }]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'NisekoAdventure',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <TopbarContainer transparentBackground={isTransparent} />

      <Container fluid>
        <HeroImage src={top} onScrollPast={setIsTransparent} />
        <HeroContent
          titleId="Hakuba.OgTitle"
          color="white"
          id="overview"
          alignment="center"
          customClass="akan"
        />
      </Container>

      <Subtitles
        className="mt-5"
        subtitleIds={['Hakuba.OgDescription', 'HakubaAdventure.bannerText3']}
      />
      <TourDetails details={getTourDetails('HakubaAdventure')} className="top-margin" />

      <SingleColumnComponent
        child={
          <div className="button-submit">
            <a
              className="w-100 text-center"
              href={inquireLink}
              id="btn_send_inquiry_1 d-flex justify-content-center align-items-center"
            >
              <FormattedMessage id="LandingPage.sendInquiryButton" />
            </a>
          </div>
        }
        columnSize={3}
        classNameCard="mt-3 pt-3"
      />

      <SectionComponent id="highlights" title="Highlights" wide fluid>
        <Image src={highlights} alt="bikes image" fluid />
        <SingleColumnComponent
          classNameRow="top-margin"
          classNameCard="no-padding-left-right-for-small-screen"
          child={
            <>
              <HighlightSection
                titleId="HakubaAdventure.highlights1"
                contentId="HakubaAdventure.highlights2"
              />
              <HighlightSection
                titleId="HakubaAdventure.highlights3"
                contentId="HakubaAdventure.highlights4"
              />
              <HighlightSection
                titleId="HakubaAdventure.highlights5"
                contentId="HakubaAdventure.highlights6"
              />
            </>
          }
        />
      </SectionComponent>

      <SectionComponent id="about" title="About" fluid>
        <TwoColumnComponent
          layoutType="intl"
          leftChild={['HakubaAdventure.about1', 'HakubaAdventure.about2']}
          rightChild={[
            'HakubaAdventure.includeList1',
            'HakubaAdventure.includeList2',
            'HakubaAdventure.includeList3',
            'HakubaAdventure.includeList4',
            'HakubaAdventure.includeList5',
            'HakubaAdventure.includeList6',
          ]}
          totalWidth={8}
          title={<FormattedMessage id="NisekoAdventure.aboutListTitle" />}
          renderIntLayoutRightCol="mt-4"
          renderIntlLayoutRightCard="two-column-card-small"
          rightCardBodyClass="padding-top"
          leftCardBodyClass="about-padding-left-right"
        />
        <Image src={aboutImg} alt="Image of bikes" fluid />
      </SectionComponent>

      <SectionComponent
        id="area"
        title={<FormattedMessage id="HakibaAdventure.sectionTitle" />}
        wide
        fluid
      >
        <Image src={area} alt="Sky image" fluid />

        <SingleColumnComponent
          child={
            <>
              <p className="regular-text-area text-center text-start-small-screen">
                <FormattedMessage id="HakubaAdventure.Hakuba1" />
              </p>
              <p className="regular-text-area text-center text-start-small-screen">
                <FormattedMessage id="HakubaAdventure.Hakuba2" />
              </p>
            </>
          }
          classNameCard="no-padding-left-for-small-screen"
        />

        <TwoColumnComponent
          layoutType="card"
          leftChild={[area2]}
          rightChild={[area3]}
          totalWidth={8}
          renderCardLayoutCardBody="paddingNone"
          rightCardBodyClass="paddingNone"
        />
      </SectionComponent>

      <SectionComponent id="guide" title="Guide" fluid>
        <TwoColumnComponent
          layoutType="card"
          leftChild={[{ url: guide, className: 'guide-pic responsive-img' }]}
          rightChild={[
            { id: 'HakubaAdventure.guide1', className: 'guide-name' },
            { id: 'HakubaAdventure.guide2', className: 'regular-text-guide' },
          ]}
          totalWidth={12}
          renderCardLayoutCardBody="paddingNone"
          rightCardBodyClass="padding"
        />
      </SectionComponent>

      <SectionComponent id="options" title="Options" fluid>
        <TwoColumnComponent
          layoutType="intl"
          leftChild={['HakubaAdventure.optionLeft1', 'HakubaAdventure.optionLeft2']}
          rightChild={[
            'HakubaAdventure.optionRight1',
            'HakubaAdventure.optionRight2',
            'HakubaAdventure.optionRight3',
            'HakubaAdventure.optionRight4',
            'HakubaAdventure.optionRight5',
            'HakubaAdventure.optionRight6',
          ]}
          totalWidth={8}
          renderIntLayoutRightCol="mt-4"
          renderIntlLayoutRightCard="two-column-card-small"
        />
        <div className="mb-5 mt-4">
          <Image src={option1} alt="cat image" fluid />
        </div>

        <Image src={option2} alt="whiskey image" fluid />
      </SectionComponent>

      <SectionComponent id="accommodations" title="Accommodations" fluid>
        <SingleColumnComponent
          columnSize={12}
          child={
            <>
              <p className="regular-text text-center padding">
                <FormattedMessage id="HakubaAdventure.accommodations1" />
              </p>
              <p className="regular-text text-center padding">
                <FormattedMessage id="HakubaAdventure.accommodations2" />
              </p>
            </>
          }
          classNameCard="px-0"
          classNameCol="px-0"
          classNameRow="px-0"
        />
        <ImageGalleryComponent imageList={imageList} />
      </SectionComponent>

      <SectionComponent id="" title="">
        <SingleColumnComponent
          child={
            <>
              <p className="small-text text-center mt-0 pt-0">
                <FormattedMessage id="RishiriAdventure.getStarted" />
              </p>
              <div className="button-submit">
                <a className="w-100" href={inquireLink} id="btn_send_inquiry_1">
                  <FormattedMessage id="LandingPage.sendInquiryButton" />
                </a>
              </div>
            </>
          }
          columnSize={8}
          classNameCard="mt-0 pt-0"
        />
      </SectionComponent>

      <SectionComponent title="More Adventures">
        <SuggestedAdventures cards={cardsWinterAndSummer} exclude="HakubaAdventurePage" />
      </SectionComponent>
      <Footer showBanner={false} />
    </PageBootstrap>
  );
};

const { object } = PropTypes;

AdventurePageComponent.propTypes = {
  currentUser: propTypes.currentUser,

  // from withRouter
  history: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const AdventurePage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(AdventurePageComponent);

export default AdventurePage;
